import {Inject, Injectable} from "ng-metadata/core";
import {MappingTablesCache} from "../mappingTablesCache/mappingTablesCache.service";
import {getEqualsSearchOperatorHypertextLinkingSubjectFieldEnabled} from "../appConfig/appConfigForward";

interface DeiTermConfig {
    target: string;     // Term
    source1: string;    // Action Type
    source2: string;    // Scope
    source3?: string;   // DEI Sensitive Icon
    source4?: string;   // New Term

}

@Injectable()
export class DeiTermService {
    private deiTerms: DeiTermConfig[] = [];
    private deiExactMap: { [term: string]: string } = {};
    private deiContainsList: { term: string; content: string }[] = [];
    private readonly NONE = 'None';
    private readonly EXACT = 'Exact';
    private readonly PART_OF_PHRASE = 'Part Of Phrase';

    constructor(private mappingTablesCache: MappingTablesCache,
                @Inject('$sce') private $sce: ng.ISCEService,) {
        const rows: DeiTermConfig[] = this.mappingTablesCache.getTable(
            this.mappingTablesCache.tables.DEI_TERM_CONFIGURATION
        );

        this.deiTerms = rows;
        this.initializeDeiTerms(this.deiTerms);
    }

    initializeDeiTerms(terms) {
        for (const term of terms) {

            if (!term.source3) { // We only want rules with DEI Sensitive Icon data
                continue;
            }

            const key = term.target.toLowerCase().trim();
            const content = this.$sce.trustAsHtml(term.source3);

            if (term.source2 === this.EXACT) {
                this.deiExactMap[key] = content;
            } else if (term.source2 === this.PART_OF_PHRASE) {
                this.deiContainsList.push({ term: key, content });
            }
        }
    }


    /**
     * Check if a selected facet matches any configured term
     */
    public checkFacet(facetValue: string): boolean {
        for (const term of this.deiTerms) {
            if (term.source1 !== this.NONE) { // Displayed facets can only have 'None' DEI action
                continue;
            }

            const configuredTerm = (term.target && term.target.toLowerCase()) || '';
            const userValue = facetValue.toLowerCase().trim();

            if (term.source2 === this.EXACT) {
                if (userValue === configuredTerm) {
                    return true;
                }
            } else if (term.source2 === this.PART_OF_PHRASE) {
                if (userValue.includes(configuredTerm)) {
                    return true;
                }
            }
        }

        return false;
    }

    public getDeiTerms(){
        return this.deiTerms;
    }

    public cleanDEIMarkers(value: string): string {
        return value.replace(/\$\$(DEIREPLACEDNOTE(?:_(\d+|\[\[.*?\]\]))?|DEIREPLACED|DEINOTE)\s*/gi, '');
    }

    public cleanDEINOTE(value: string): string {
    return value.replace(/\$\$DEINOTE\s*/g, '');
    }

    private isDeiReplaced(value: string){
       return  /\$\$DEIREPLACED(?![A-Z])/i.test(value)
    }

    public getTrustedPopupContent(userValue: string): string | undefined {
        if (!userValue || this.isDeiReplaced(userValue)) {
            return undefined;  // We only care terms with Note
        }

        // 1. Check if it's a $$DEIREPLACEDNOTE
        const replaceNotedMatch = userValue.match(/\$\$DEIREPLACEDNOTE_\[\[(.+?)\]\]/i);
        if (replaceNotedMatch && replaceNotedMatch[1]) {
            const originalVal = replaceNotedMatch[1].toLowerCase().trim();
            if (this.deiExactMap[originalVal]) {
                return this.deiExactMap[originalVal];
            }

            return undefined;
        }

        let cleanVal = this.cleanDEIMarkers(userValue);

        const parts = cleanVal.split("$$Q", 2);
        const part0 = (parts[0] || "").trim();
        const part1 = (parts[1] || "").trim();

        const neededPart =  getEqualsSearchOperatorHypertextLinkingSubjectFieldEnabled() ? part1 || part0 : part0;
        const val = neededPart.toLowerCase().trim();

        // 2. Try exact match
        if (this.deiExactMap[val]) {
            return this.deiExactMap[val];
        }

        // 3. Try Part of Phrase matches
        for (const entry of this.deiContainsList) {
            if (val.includes(entry.term)) {
                return entry.content;
            }
        }

        return undefined;
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/deiTerm.service.ts